import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=6b6d2b8f&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=6b6d2b8f&prod&lang=scss"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=6b6d2b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d2b8f",
  null
  
)

export default component.exports